import { editClientAccessToken, getClientTokenList } from "@payping/redux/actions";
import { Button, Flex, LegacyForm, Modal, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { useAppDispatch } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { ConfirmModalProps } from "@/components/DashIpg/ConfirmModal";
import { OtpCode } from "@/components/OtpCode";

interface Props {
  clientId: string;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setConfirmModalOpen: Dispatch<SetStateAction<boolean>>;
  setConfirmModalData: Dispatch<SetStateAction<ConfirmModalProps | undefined>>;
}

const TokenRenew: FC<Props> = (props) => {
  const { clientId, setOpen, open, setConfirmModalData, setConfirmModalOpen } = props;
  const { t } = useAppTranslation();
  const dispatch = useAppDispatch();
  const [form] = LegacyForm.useForm<any>();
  const [isOtpValid, setIsOtpValid] = useState(false);

  function hideModal() {
    form.resetFields();
    setOpen(false);
  }

  const [, handleRenew] = useMessagedAsyncFn(async () => {
    const { token } = await dispatch(
      editClientAccessToken({
        clientId,
      }),
    );
    if (token) {
      setConfirmModalData({ showGuide: false, token });
      setConfirmModalOpen(true);
    } else {
      hideModal();
      Modal.error({
        content: t("token.timeLimitError"),
        title: "خطا",
      });
    }
    await dispatch(getClientTokenList());
  }, [clientId]);

  return (
    <Modal
      title={t("token.renew.renewToken")}
      open={open}
      okText={t("token.renew.renewToken")}
      onOk={() => form.submit()}
      cancelText={t("return")}
      onCancel={() => hideModal()}
      footer={
        <Flex gap={"small"}>
          <Button type={"default"} onClick={() => hideModal()}>
            {t("return")}
          </Button>
          <Button onClick={() => form.submit()} type={"primary"} disabled={!isOtpValid}>
            {t("token.renew.renewToken")}
          </Button>
        </Flex>
      }
    >
      <Typography.Paragraph className="text--danger">{t("token.renew.attention")}</Typography.Paragraph>
      <LegacyForm form={form} onFinish={handleRenew} layout={"vertical"}>
        <OtpCode form={form} onVerify={(isVerified) => setIsOtpValid(isVerified)} />
      </LegacyForm>
    </Modal>
  );
};

export default TokenRenew;
